import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f7f7f7",
  foreground: "#210331",
  surface: "#ffffff",
  surfaceForeground: "#210331",
  surfaceSecondary: "#f2f2f2",
  surfaceSecondaryForeground: "#210331",
  surfaceTertiary: "#ebebeb",
  surfaceTertiaryForeground: "#210331",
  overlay: "#ffffff",
  overlayForeground: "#210331",
  muted: "#71717a",
  default: "#f4f4f5",
  defaultForeground: "#210331",
  accent: "#8fbf00",
  accentForeground: "#210331",
  danger: "#f43f5e",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#210331",
  success: "#10b981",
  successForeground: "#210331",
  separator: "#b8b8ba",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(0, 0, 0, 0.1)",
  glassHighlight: "rgba(0, 0, 0, 0.08)",
  glow0: "rgba(182, 230, 0, 0.14)",
  glow1: "rgba(232, 110, 60, 0.1)",
  glow2: "rgba(182, 230, 0, 0.08)",
  mutedForeground: "#210331",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(0, 0, 0, 0.1)",
  fieldPlaceholder: "rgba(0, 0, 0, 0.4)",
  fieldBackground: "rgba(0, 0, 0, 0.03)",
  segment: "#ffffff",
  segmentForeground: "#210331",
  link: "#210331",
  focus: "#8fbf00",
  fieldForeground: "#210331",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#b8b8ba",
  primary: "#8fbf00",
  primaryForeground: "#210331",
  secondary: "#f4f4f5",
  secondaryForeground: "#210331",
  backdrop: "rgba(0, 0, 0, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#000000",
  foreground: "#fafafa",
  surface: "#1c1f24",
  surfaceForeground: "#fafafa",
  surfaceSecondary: "#23272d",
  surfaceSecondaryForeground: "#fafafa",
  surfaceTertiary: "#2c3036",
  surfaceTertiaryForeground: "#fafafa",
  overlay: "#22262b",
  overlayForeground: "#fafafa",
  muted: "#a1a1aa",
  default: "#33373d",
  defaultForeground: "#fafafa",
  accent: "#b6e600",
  accentForeground: "#1c2024",
  danger: "#e11d48",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#210331",
  success: "#10b981",
  successForeground: "#210331",
  separator: "#3a3f46",
  glassBackground: "rgba(10, 10, 10, 0.985)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.25)",
  glow0: "rgba(182, 230, 0, 0.5)",
  glow1: "rgba(232, 110, 60, 0.42)",
  glow2: "rgba(182, 230, 0, 0.3)",
  mutedForeground: "#fafafa",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(255, 255, 255, 0.1)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.4)",
  fieldBackground: "rgba(255, 255, 255, 0.03)",
  segment: "#33373d",
  segmentForeground: "#fafafa",
  link: "#fafafa",
  focus: "#b6e600",
  fieldForeground: "#fafafa",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#3a3f46",
  primary: "#b6e600",
  primaryForeground: "#1c2024",
  secondary: "#23272d",
  secondaryForeground: "#fafafa",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
